import { post } from './http';

export const postInquire = async (body) => {
  //console.log(body);
  const response = await post(`/api/campaigncontactus/sendinquire`, body);
  return response.status == 200;
};